// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__250eo","buttons":"PendingPaymentAlert_buttons__2-wX-"};